export default "__VITE_ASSET__B_lV7Bn3__"